import { render, staticRenderFns } from "./ClinicianAlertList.vue?vue&type=template&id=1d5582ad"
import script from "./ClinicianAlertList.vue?vue&type=script&lang=js"
export * from "./ClinicianAlertList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports